export const environment = {
   'API_URL' : window.location.origin.match('localhost') !== null ? 'http://localhost:9090' : 'https://api.youscanme.com',
   'APP_PATH' : window.location.origin.match('localhost') !== null ? 'http://localhost:4200' : 'https://user.youscanme.com',
   'API_LIVE_URL' : 'http://localhost:9090',
   'ASSETS_URL' : window.location.origin.match('localhost') !== null ? 'http://localhost:9090' : 'https://api.youscanme.com' 
}